import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TransactionDocuments } from '../../../../models/TransactionDocuments/transaction-documents.model';

export interface AddCommonDocumentTypeRequest {
    engagementId: number;
    name: string;
}

export const AddCommonDocumentType = createAsyncThunk(
    'transactionDocuments/addCommonDocumentType',
    async (params: AddCommonDocumentTypeRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/Marketplace/Engagements/${params.engagementId}/TransactionDocuments/CommonDocumentTypes`,
                { name: params.name }
            );

            if (response.status !== 200) {
                throw new Error('Failed to add the common document type');
            }

            return response.data as TransactionDocuments;
        } catch (error) {
            createNotification('Could not add the common document type.', 'error');
            throw error;
        }
    }
);
